import { REDUCER_KEY_CAS_NUMBER } from '@Containers/CasNumber/constants';
import { getKey } from '@Containers/CasNumber/utils';

export const casNumberState = (state) => state.get(REDUCER_KEY_CAS_NUMBER);

export const casNumberStateByDatabaseIdSubstanceId = (state, { databaseId, substanceId }) => {
  const s = casNumberState(state);
  const key = getKey(databaseId, substanceId);
  return s && s[key];
};

export const casNumberStateByResultName = (state, { resultName }) => {
  const s = casNumberState(state);
  return s && s[resultName];
};

export const casNumberStateForSubstance = (state, ownProps) => casNumberStateByDatabaseIdSubstanceId(state, ownProps);

export const casNumberLoading = (state, ownProps) => {
  const s = casNumberStateForSubstance(state, ownProps);
  return s && s.isLoading;
};

export const casNumberError = (state, ownProps) => {
  const s = casNumberStateForSubstance(state, ownProps);
  return s && s.errorNumber;
};

export const casNumber = (state, ownProps) => {
  const s = casNumberStateForSubstance(state, ownProps);
  return s && s.casNumber;
};
